import { createAction, handleActions } from "redux-actions";

const actionScope = "PROVIDER_SESSION_";

export const providerSessionRequestFailed = createAction(actionScope + "REQUEST_FAIL");

export const loadProviderODMRequest = createAction(actionScope + "LOAD_PROVIDER_ODM_REQUEST");
export const loadProviderODMSuccess = createAction(actionScope + "LOAD_PROVIDER_ODM_SUCCESS");

export const setProviderODMRequest = createAction(actionScope + "SET_PROVIDER_ODM_REQUEST");
export const setProviderODMSuccess = createAction(actionScope + "SET_PROVIDER_ODM_SUCCESS");

export const updateProviderRequest = createAction(actionScope + "UPDATE_PROVIDER_REQUEST");
export const updateProviderSuccess = createAction(actionScope + "UPDATE_PROVIDER_SUCCESS");

export const deleteProviderRequest = createAction(actionScope + "DELETE_PROVIDER_REQUEST");
export const deleteProviderSuccess = createAction(actionScope + "DELETE_PROVIDER_SUCCESS");

export const loadProviderAssessmentsRequest = createAction(
  actionScope + "LOAD_PARTNER_ASSESSMENTS_REQUEST"
);
export const loadProviderAssessmentsSuccess = createAction(
  actionScope + "LOAD_PARTNER_ASSESSMENTS_SUCCESS"
);

export const setProviderAssessmentsRequest = createAction(
  actionScope + "SET_PARTNER_ASSESSMENTS_REQUEST"
);
export const setProviderAssessmentsSuccess = createAction(
  actionScope + "SET_PARTNER_ASSESSMENTS_SUCCESS"
);

export const reflectUpdatedAssessmentODMRequest = createAction(
  actionScope + "REFLECT_UPDATED_ASSESSMENT_ODM_REQUEST"
);
export const reflectUpdatedAssessmentODMSuccess = createAction(
  actionScope + "REFLECT_UPDATED_ASSESSMENT_ODM_SUCCESS"
);

export const loadProviderPatientsRequest = createAction(
  actionScope + "LOAD_PARTNER_PATIENTS_REQUEST"
);
export const loadProviderPatientsSuccess = createAction(
  actionScope + "LOAD_PARTNER_PATIENTS_SUCCESS"
);

export const setProviderPatientsRequest = createAction(
  actionScope + "SET_PARTNER_PATIENTS_REQUEST"
);
export const setProviderPatientsSuccess = createAction(
  actionScope + "SET_PARTNER_PATIENTS_SUCCESS"
);

export const reflectUpdatedPatientODMRequest = createAction(
  actionScope + "REFLECT_UPDATED_PATIENT_ODM_REQUEST"
);
export const reflectUpdatedPatientODMSuccess = createAction(
  actionScope + "REFLECT_UPDATED_PATIENT_ODM_SUCCESS"
);

// selectors
export const providerODMSelector = state => state.providerSession.providerODM;
export const providerAssessmentsSelector = state => state.providerSession.providerAssessments;
export const providerPatientsSelector = state => state.providerSession.providerPatients;

// initial state
const initialState = {
  //these members use the omnDataModel defined by the JSON in this project
  providerODM: null,

  providerAssessments: null,
  providerPatients: null,
};

// reducers
export default handleActions(
  {
    [providerSessionRequestFailed]: state => state,

    [loadProviderODMRequest]: state => state,
    [loadProviderODMSuccess]: (state, { payload }) => ({
      ...state,
    }),

    [setProviderODMRequest]: state => state,
    [setProviderODMSuccess]: (state, { payload }) => ({
      ...state,
      providerODM: payload,
    }),

    [updateProviderRequest]: state => state,
    [updateProviderSuccess]: (state, { payload }) => ({
      ...state,
    }),
    [deleteProviderRequest]: state => state,
    [deleteProviderSuccess]: (state, { payload }) => ({
      ...state,
    }),

    [loadProviderAssessmentsRequest]: state => state,
    [loadProviderAssessmentsSuccess]: (state, { payload }) => ({
      ...state,
    }),

    [setProviderAssessmentsRequest]: state => state,
    [setProviderAssessmentsSuccess]: (state, { payload }) => ({
      ...state,
      providerAssessments: payload,
    }),

    [reflectUpdatedAssessmentODMRequest]: state => state,
    [reflectUpdatedAssessmentODMSuccess]: (state, { payload }) => ({
      ...state,
      providerAssessments: payload,
    }),

    [loadProviderPatientsRequest]: state => state,
    [loadProviderPatientsSuccess]: (state, { payload }) => ({
      ...state,
    }),

    [setProviderPatientsRequest]: state => state,
    [setProviderPatientsSuccess]: (state, { payload }) => ({
      ...state,
      providerPatients: payload,
    }),

    [reflectUpdatedPatientODMRequest]: state => state,
    [reflectUpdatedPatientODMSuccess]: (state, { payload }) => ({
      ...state,
      providerPatients: payload,
    }),
  },
  initialState
);
